import { Container, Typography, Box } from '@mui/material'

export default function MyOrdersPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          My Orders
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          This page will display the user's order history and tracking information.
        </Typography>
      </Box>
    </Container>
  )
}